import { Skeleton } from '@mui/material'

const ArticleDateSkeleton: React.FC = () => {
  return <Skeleton width={150} />
}

export default ArticleDateSkeleton
